import { setupSessionTokenDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const tokenEnvelopeSchema = dataEnvelopeSchema(setupSessionTokenDTOSchema);
const noContentSchema = z.undefined();
const SETUP_SESSIONS_PATH = `${WEB_API_PREFIX}/setup-sessions`;
export function createSetupSessionsResource(transport) {
    return {
        async exchange(input) {
            const envelope = await transport.request({
                path: `${SETUP_SESSIONS_PATH}/exchange`,
                schema: tokenEnvelopeSchema,
                method: 'POST',
                body: input,
                // The code is the credential; a stale user token must not ride along.
                auth: 'none',
            });
            return envelope.data;
        },
        async endCurrent() {
            await transport.request({
                path: `${SETUP_SESSIONS_PATH}/current`,
                schema: noContentSchema,
                method: 'DELETE',
            });
        },
    };
}
//# sourceMappingURL=setup-sessions.js.map